import { ErrorView } from "@nef/core"

const NoMatch = () => {
  return (
    <>
      <ErrorView
        error="404 | Page not found"
        description="Apologies, we can’t find the page you are looking for"
        buttonProps={{ children: "Go to home", onClick: () => window.location.replace("/") }}
      />
    </>
  )
}

export default NoMatch
